import {
  ENDPOINT_DOCUMENTS_UPLOAD_DEFAULT,
  ENDPOINT_KYC_BANK_SUBMIT,
  ENDPOINT_KYC_COMPANY_SUBMIT,
  ENDPOINT_KYC_DOCUMENTS_REMOVE,
  ENDPOINT_KYC_DOCUMENTS_SUBMIT,
  ENDPOINT_KYC_OWNER_CREATE,
  ENDPOINT_KYC_OWNER_REMOVE,
  ENDPOINT_KYC_OWNER_UPDATE,
  ENDPOINT_KYC_PERSONAL_SUBMIT,
  ENDPOINT_KYC_STATUS
} from "../../constants/api";

const {
  apiRequest,
} = require('../ws');
const {
  uploadDocument,
} = require('../upload');

export function apiV2KycGetStatus() {
  return apiRequest(ENDPOINT_KYC_STATUS, {}, () => {
    return {
      // verification_state: 'pending',
      verification_state: 'rejected',
      message: 'Please contact Lunu Support.',
      status: 'completed',
      company: {
        status: 'completed',
        company: {},
      },
      profile: {
        status: 'completed',
        profile: {},
      },
      owner: {
        status: 'completed',
        list: [],
      },
      document: {
        status: 'completed',
        list: [],
      },
      bank: {
        status: 'completed',
        bank: {},
      },
    };
  });
}
export function apiV2KycCompanyProfileSubmit(params) {
  return apiRequest(ENDPOINT_KYC_COMPANY_SUBMIT, params);
}
export function apiV2KycPersonalProfileSubmit(params) {
  return apiRequest(ENDPOINT_KYC_PERSONAL_SUBMIT, params);
}
export function apiV2KycDocumentsSubmit(params) {
  return apiRequest(ENDPOINT_KYC_DOCUMENTS_SUBMIT, params);
}
export function apiV2KycBankSubmit(params) {
  return apiRequest(ENDPOINT_KYC_BANK_SUBMIT, params);
}

export function apiV2KycOwnerCreate(params) {
  return apiRequest(ENDPOINT_KYC_OWNER_CREATE, params);
}
export function apiV2KycOwnerUpdate(params) {
  return apiRequest(ENDPOINT_KYC_OWNER_UPDATE, params);
}
export function apiV2KycOwnerRemove(params) {
  return apiRequest(ENDPOINT_KYC_OWNER_REMOVE, params);
}

export function apiV2KycDocumentRemove(params) {
  return apiRequest(ENDPOINT_KYC_DOCUMENTS_REMOVE, params);
}
export function apiV2KycDocumentUpload(params) {
  return uploadDocument({
    ...params,
    uploadUrl: params.uploadUrl || ENDPOINT_DOCUMENTS_UPLOAD_DEFAULT,
  });
}
